import { FC } from 'react'
import { LayoutHeader } from '@/components/domains/layouts'
import PolicyAgreement from '@/components/domains/policy/PolicyAgreement'

const PagePolicyAgreement: FC = () => {
  return (
    <>
      <LayoutHeader />
      <PolicyAgreement />
    </>
  )
}

export default PagePolicyAgreement
